module.exports = __webpack_public_path__ + "img/p2-p3-text.6507ba6f.png";